import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Login failed');
        return;
      }

      localStorage.setItem('adminToken', data.token);
      navigate('/dashboard');
    } catch (err) {
      setError('Server error, please try again later');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100 ">
      <div className="card p-4 shadow bg-success" style={{ maxWidth: '400px', width: '100%' }}>
      
        <img src='https://binzal.com/static/media/logo.eb89ff6bc62251c9ae66.png' className=' image-fluid py-3 px-5' alt='logo' ></img>
        
        {error && (
          <div className="alert alert-danger py-1 text-center" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label text-light fw-bold">Email address</label>
            <input
              type="email"
              className="form-control bg-success-subtle py-2 px-3 rounded"
              id="email"
              autoFocus
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin email"
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label fw-bold text-light">Password</label>
            <input
              type="password"
              className="form-control bg-success-subtle"
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>

          <div className="d-grid">
            <button type="submit" className="btn btn-dark text-light ">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
